export type EntityPermissionData = {validated: boolean; reason?: string}
export type EntityWithPermission = {uid: string; permissionData?: EntityPermissionData}

type PermissionCheckValues = {
  class?: {uid?: string} | null
  service?: {uid?: string} | null
  selectedSessions?: {classId?: string | null}[]
}

/**
 * Every entity the summary must check before booking. A multi-session class booking can hold
 * sessions of several classes, while `class` only names one of them — so every selected
 * session's class is checked too. WBA-4234.
 */
export const getEntityIdsToValidate = (type: 'class' | 'service', values: PermissionCheckValues): string[] => {
  if (type !== 'class') {
    return values.service?.uid ? [values.service.uid] : []
  }
  const ids = [values.class?.uid, ...(values.selectedSessions || []).map((session) => session.classId)]
  return ids.filter((id, index): id is string => !!id && ids.indexOf(id) === index)
}

/** The first of `ids` the server says the user may not book, if any. */
export const findRestrictedPermission = (
  entities: EntityWithPermission[],
  ids: string[],
): EntityPermissionData | undefined =>
  ids
    .map((id) => entities.find((entity) => entity.uid === id)?.permissionData)
    .find((permissionData) => !!permissionData && !permissionData.validated)
